<template>
  <v-layout fill-height row wrap style="background-color: #f4f5f9">
    <v-flex xs12>
      <NewLargeBookForm
        v-if="bookingForm != null"
        @madeBooking="madeBooking"
        @locationsChanged="makeBookingLocationsChanged"
        :bookingForm="bookingForm"
        :initialNumber="initialNumber"
        :filters="true"
      />
      <v-flex pa-2>
        <h2 v-if="mode == 'close'">You may now close this tab</h2>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
// @ is an alias to /src
import Home from "@/components/Home.vue";
import OverwatchCard from "@/components/widget/OverwatchCard.vue";
import OverwatchMap from "@/components/overwatch/OverwatchMap.vue";

import TaxiList from "@/components/overwatch/TaxiList.vue";

import AssignTrip from "@/components/booking/AssignTrip.vue";

import SmallBookForm from "@/components/booking/SmallBookForm.vue";

import LargeBookForm from "@/components/booking/LargeBookForm.vue";

import UpcomingTrips from "@/components/overwatch/UpcomingTrips.vue";
import ActiveTrips from "@/components/overwatch/ActiveTrips.vue";

import { BookingForm } from "@/components/util/BookingForm.js";

import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import moment from "moment";

import { replaceStart } from "@/components/util/PhoneNumbers.js";
import NewLargeBookForm from '../../components/booking/form/NewLargeBookForm'

global.jQuery = require("jquery");
var $ = global.jQuery;

export default {
  name: "NewBook",
  components: {
    NewLargeBookForm,
    Home,
    OverwatchCard,
    OverwatchMap,
    TaxiList,
    UpcomingTrips,
    ActiveTrips,
    SmallBookForm,
    LargeBookForm,
    AssignTrip,
  },
  data: function () {
    return {
      loading: true,
      rideTypes: [],
      rideTypeEtas: null,
      bookingForm: null,
      mode: null,
      initialNumber: null,
    };
  },
  created: function () {},
  beforeDestroy: function () {
    clearTimeout(this.getInformationTimer);
  },
  mounted: function () {
    var vm = this;

    if (this.$route.query.callerid != null) {
      this.$route.query.contactNumber = this.$route.query.callerid;
    }

    if (this.$route.query.contactNumber != null) {
      this.initialNumber = this.$route.query.contactNumber;
      this.initialNumber = this.initialNumber.replace(/\s/g, "");
      this.initialNumber = replaceStart(this.initialNumber);
      this.initialNumber = this.initialNumber.replace("+", "");

      console.log("Initial Number " + this.initialNumber);
    } else {
      this.initialNumber = "";
    }

    console.log(this.$route.query)
    if (this.$route.query.rebook != null && this.$route.query.type && this.$route.query.type === 'return') {
      console.log("We are rebooking as return book!");
      this.$store.commit('booking/setIsReturnBooking', true)
      this.getBookingForReturnBooking(this.$route.query.rebook);
    }
    if (this.$route.query.rebook != null && !this.$route.query.type) {
      console.log("We are rebooking so fetch!");

      this.getBookingForRebook(this.$route.query.rebook);
    }

    vm.getRideTypes();
  },
  computed: {},
  methods: {
    async getBookingForRebook(bookingID) {
      this.loadingEditBooking = true;

      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          this.bookingForm.rebook(response.data.booking);
          this.bookingForm.getCustomer(
            response.data.booking.user.contact_number
          );
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    async getBookingForReturnBooking(bookingID) {
      this.loadingEditBooking = true;

      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          this.bookingForm.returnBook(response.data.booking);
          this.bookingForm.getCustomer(
            response.data.booking.user.contact_number
          );
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    madeBooking: function () {
      // this.createBookingDialog = null;
      this.bookingForm = null;
      // this.actionBoxMode = null;

      // this.$refs.taxiMap.clear();
      // this.$refs.taxiMap.recenter();

      console.log("Closing");
      this.mode = "close";

      window.close();
    },
    makeBookingLocationsChanged: function (val) {
      console.log("Updating map");
      if (this.$refs.taxiMap) {
        this.$refs.taxiMap.zoomToMakingBooking(this.bookingForm.booking);
      }
    },
    makeBooking: function () {
      console.log("Showing booking action box");
    },
    getRideTypes: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.rideTypes = response.data;

        var bookingForm = new BookingForm(
          this.rideTypes,
          this.initialNumber,
          this.$store
        );

        var vm = this;

        // setTimeout(function() {
        vm.bookingForm = bookingForm;
        // }, 2000);

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
  },
};
</script>
